import { Box } from '@chakra-ui/react';
import { Route, Routes } from 'react-router-dom';
import MarketingHeader from 'features/marketing/components/MarketingHeader';
import MarketingFooter from 'features/marketing/components/MarketingFooter';
import routes from 'routes/marketing';

export default function MarketingLayout() {
  return (
    <Box minH="100vh" bg="white" display="flex" flexDirection="column">
      <MarketingHeader />
      <Box flex="1">
        <Routes>
          {routes.map((route, i) => (
            <Route key={i} path={route.path} element={route.component} />
          ))}
        </Routes>
      </Box>
      <MarketingFooter />
    </Box>
  );
}
